import { render, staticRenderFns } from "./MareTiers.vue?vue&type=template&id=22160ebc&"
import script from "./MareTiers.vue?vue&type=script&lang=js&"
export * from "./MareTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports